import { render, staticRenderFns } from "./flexfield.vue?vue&type=template&id=69efdbd2&scoped=true"
import script from "./flexfield.vue?vue&type=script&lang=js"
export * from "./flexfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69efdbd2",
  null
  
)

export default component.exports